import ApiService from './api';
import { safeArray } from '../utils/money';

// 运营模式：mor=平台托管 / psp=直连(Connect)
export type PaymentMode = 'mor' | 'psp';

// 单个支付方式定义
export interface PaymentMethodItem {
  method: string; // 方式代码，如 card / apple_pay / sepa_debit ...
  label: string; // 后端给出的展示名
  provider: string; // stripe / epay / crypto
  integration_type: string; // stripe_element / redirect / qr / crypto
  enabled: boolean; // 当前是否启用
}

// method-catalog 返回结构
export interface PaymentMethodCatalog {
  mode: PaymentMode;
  methods: PaymentMethodItem[];
}

const DEFAULT_CATALOG: PaymentMethodCatalog = {
  mode: 'psp',
  methods: [],
};

export class PaymentMethodsService {
  /**
   * 获取支付方式目录（含当前启用状态与运营模式）
   */
  static async getCatalog(): Promise<PaymentMethodCatalog> {
    const response = await ApiService.get<PaymentMethodCatalog>(
      '/merchant/payments/method-catalog'
    );
    const data = response.data || ({} as PaymentMethodCatalog);
    return {
      mode: (data.mode as PaymentMode) || DEFAULT_CATALOG.mode,
      methods: safeArray<PaymentMethodItem>(data.methods),
    };
  }

  /**
   * 保存启用的支付方式。
   * automatic 模式传 ["automatic"]，手动模式传所有启用方式代码。
   */
  static async updateCheckoutMethods(methods: string[]): Promise<void> {
    await ApiService.put('/merchant/payments/checkout-methods', { methods });
  }
}

export default PaymentMethodsService;
